<template>
  <v-app :dark="isDark" :class="{ 'dark-mode': isDark }">
    <v-container>
    <div class="textInputWrapper">
      <v-text-field
          v-model="amount"
          type="number"
          persistent-placeholder
          label="Напиши, сколько нужно"
          @input="onInput"
          :dark="isDark"
          class="rounded-lg pa-5"
          style="background-color: var(--bg-color-secondary)"
      ></v-text-field>
      <v-text-field
          v-model="reason"
          label="Выберите причину"
          persistent-placeholder
          :dark="isDark"
          class="rounded-lg pa-5"
          append-icon="mdi-chevron-right"
          @click:append="selectReason"
          style="background-color: var(--bg-color-secondary)"
      />
    </div>
      <div>
        <p class="footer-text">
          Сумма к выводу
          <span class="amount">{{ amount || 0 }} ₸</span>
        </p>
        <p class="footer-text">
          Комиссия
          <span class="amount">0 ₸</span>
        </p>
      </div>
      <div>
        <v-btn
            color="#1751D0"
            class="ma-0 white--text"
            style="width: 100%; border-radius: 12px"
            large
            block
            @click="makeRequest"
            :dark="isDark"
            :disabled="!amount"
        >
          Отправить заявку
        </v-btn>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import {storage} from "@orta/bridge";

export default {
  data() {
    return {
      amount: null,
      reason: '',
      currentTask: null,
      theme: 'light',
      activeTab: 0,
      listItems: [
        {title: 'Размер зарплаты', subtitle: '111 000 ₸', icon: 'mdi-credit-card-plus'},
        {title: 'Из 22 рабочих дней', subtitle: '15 дней отработано', icon: 'mdi-calendar-multiselect'},
        {title: 'Стоимость рабочего дня', subtitle: '4 321,23 ₸', icon: 'mdi-cash-multiple'},
        {title: 'Формула вычисления', subtitle: '111 000 ₸  * 15 = 115 000 ₸', icon: 'mdi-poll'},
      ]
    };
  },
  computed: {
    isBridgeAvailable() {
      return require('@orta/bridge').isWebViewBridgeAvailable()
    },
    isDark() {
      return this.theme === 'dark';
    }
  },
  created() {
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';
  },
  mounted() {
    if (this.isBridgeAvailable) {
      require('@orta/bridge').setTitle('Запрос аванса');
      require('@orta/bridge').backArrow.setMode(true);
      require('@orta/bridge').backArrow.setVisible(true);
      require('@orta/bridge').backArrow.setOnClickHandler(this.goBack);
    }
  },
  methods: {
    async makeRequest() {
      try {
        const getRequests = await storage.getItem('requests');
        const storedRequest = JSON.parse(getRequests);
        if (storedRequest) {
          await storage.setItem('requests', JSON.stringify([...storedRequest, {id: 0, amount: this.amount, date: (() => {
              const now = new Date();
              return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            })(),}]));
          return this.goBack();
        }
      } catch (error) {
        console.log('get items failed', error);
        await storage.setItem('requests', JSON.stringify([
          {id: 0, amount: this.amount, date: (() => {
              const now = new Date();
              return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            })(),}
        ]))
      }
      this.goBack()
    },
    selectReason() {
      //
    },
    onInput(value) {
      // Remove decimals and non-numeric characters
      const parsed = parseInt(value);
      this.amount = isNaN(parsed) ? null : parsed;
    },
    goBack() {
      this.$router.replace({name: 'AdvanceScreen'});
    },
  }
}
</script>

<style scoped>
.footer-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-color);
}

h2 {
  color: var(--text-color);
}

.textInputWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
